/**
 * @generated SignedSource<<e346dd67f3ad27f3a4f5e334942db557>>
 * @relayHash afe5d9df70dbafc1c6bc2065adf357ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 397d514693057cc15024c65c4c8aaac04f5d1f856876f22b2cbe104860ca9834

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraJqlScopeInput = {
  board?: JiraJqlBoardInput | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type boardFilterRefinementQuery$variables = {
  boardId: string;
  cloudId: string;
  filterRefinementScope: JiraJqlScopeInput;
  isFilterRefinementHydrationEnabled: boolean;
  jql?: string | null | undefined;
};
export type boardFilterRefinementQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"boardFilterRefinement_softwareBoard" | "customFilter_softwareFilters_CustomFilterRelay">;
};
export type boardFilterRefinementQuery = {
  response: boardFilterRefinementQuery$data;
  variables: boardFilterRefinementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterRefinementScope"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFilterRefinementHydrationEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "filterRefinementScope"
},
v7 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v8 = [
  (v5/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "boardFilterRefinementQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "jql",
            "variableName": "jql"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "boardFilterRefinement_softwareBoard"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "customFilter_softwareFilters_CustomFilterRelay"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "boardFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  },
                  {
                    "kind": "Literal",
                    "name": "jqlTerm",
                    "value": "assignee"
                  },
                  (v6/*: any*/)
                ],
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                          },
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isFilterRefinementHydrationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "query",
                        "variableName": "jql"
                      },
                      (v6/*: any*/)
                    ],
                    "kind": "LinkedField",
                    "name": "hydrateJqlQuery",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                              }
                            ]
                          }
                        ],
                        "type": "JiraJqlHydratedQuery"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFilter",
            "kind": "LinkedField",
            "name": "customFilters",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "397d514693057cc15024c65c4c8aaac04f5d1f856876f22b2cbe104860ca9834",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "631c03916566edbd5db43afee84d3b8d";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
